import { BODY_PART } from '@/constant';
import { PainLevelItem } from '../component';
import cx from './index.module.scss';

interface Props {
  serviceDetail: GetServiceOrderDetailResponse;
  beforeHandData: PainLevelParams;
  afterHandData: PainLevelParams;
  orderTypeIsCommon: boolean;
}

enum BodyPartFiledName {
  Shoulder = 'shoulderPainLevel',
  Waist = 'waistPainLevel',
}

const ShockwavePainChange: React.FC<Props> = ({ serviceDetail, beforeHandData, afterHandData, orderTypeIsCommon }) => {
  return (
    <>
      <div className={cx('title', { 'shockwave-manual-title': orderTypeIsCommon })}>
        <div>本次理疗</div>
        <div>疼痛变化</div>
      </div>
      <div className={cx('content', { 'shockwave-manual-content': orderTypeIsCommon })}>
        {!orderTypeIsCommon ? (
          <PainLevelItem
            label={BODY_PART[serviceDetail?.bodyPart]}
            beforeVal={beforeHandData?.[BodyPartFiledName[serviceDetail?.bodyPart]]}
            afterVal={afterHandData?.[BodyPartFiledName[serviceDetail?.bodyPart]]}
          />
        ) : (
          <div
            className={cx('more-part', {
              'all-empty':
                (beforeHandData === null && afterHandData === null) ||
                (beforeHandData?.shoulderPainLevel === null &&
                  beforeHandData?.waistPainLevel === null &&
                  afterHandData?.shoulderPainLevel === null &&
                  afterHandData?.waistPainLevel === null),
            })}
          >
            <PainLevelItem
              label="肩部"
              beforeVal={beforeHandData?.shoulderPainLevel}
              afterVal={afterHandData?.shoulderPainLevel}
            />
            <PainLevelItem
              label="腰部"
              beforeVal={beforeHandData?.waistPainLevel}
              afterVal={afterHandData?.waistPainLevel}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ShockwavePainChange;
